module Meevo.Components.ImageFileUpload {
    angular.module("meevo.components.imageFileUpload", []);
}